import {FormattedMessage} from "react-intl";
import Row from "../../../../../../components/tag/Row";
import React from "react";
import {resolveReminder} from "../../../../../timeline/components/TimelineItemWrapper";
import {hasAdditionalCoxaInfo} from "../../../../../../utils/TimelineUtils";
import {OTLink} from "../../../../../../components/tag/OTLink";
import Urls from "../../../../../../definitions/Urls";
import {TYPE_COXA_TREATMENT_PERIOD} from "../../../../../../definitions/TimelineItems";
import {COMMON_GENERIC_PHRASE_TYPE} from "../../../../TimelineFrameUtils";


let { id: module_id } = module;

export const TimelineFrameContentDefaultDetails = ({data, genericPhrases}) => {
    const isKidneyDept = data.department && new RegExp(/\(MUNP\)/).test(data.department);
    const showCoxaInfo = hasAdditionalCoxaInfo(data);
    const reminder = resolveReminder(isKidneyDept, data);

    const getReminder = () => {
        return (
            <Row>
                <FormattedMessage id={reminder}/>
            </Row>
        );
    }

    const getCoxaInfo = () => {
        return (
            <Row>
                <FormattedMessage id={'timelineitem.coxa.additional.info.reminder'}>
                    {(txt) => <p className={'card__reminder'}>{txt}</p>}
                </FormattedMessage>
            </Row>
        );
    }

    const getKidneyDept = () => {
        return (
            <>
                <div className="row-fluid">
                    <div className="span6">
                        <i className="card-icon icon-list-ul" />{' '}
                        <OTLink
                            link="/questionnaires"
                            onClick={(e) => e.stopPropagation()}
                            className="card-link"
                        >
                            <FormattedMessage
                                id={`${module_id}.MUNP.questionnaires`}
                            />
                        </OTLink>
                    </div>
                </div>
                <div className="row-fluid">
                    <div className="span12">
                        <i className="card-icon icon-file" />{' '}
                        <OTLink
                            target="_blank"
                            onClick={(e) => e.stopPropagation()}
                            link={Urls.patientFees}
                            isExternal
                            className="card-link"
                        >
                            <FormattedMessage
                                id={`${module_id}.MUNP.patientFees`}
                            />
                        </OTLink>
                    </div>
                </div>
                <div className="row-fluid">
                    <div className="span12">
                        <p
                            className="ot-notification__description--small"
                            style={{ color: 'black' }}
                        >
                            <FormattedMessage
                                id={`${module_id}.MUNP.attention`}
                                values={{
                                    i: (chunks) => <i>{chunks}</i>,
                                    br: <br />,
                                }}
                            />
                        </p>
                    </div>
                </div>
            </>
        );
    }

    const getCommonGenericPhrases = () => {
        const commonPhrases = genericPhrases.find(gP => gP.type === COMMON_GENERIC_PHRASE_TYPE);

        if (!commonPhrases) {
            return <></>
        }

        return (
            <>
                { commonPhrases.phrases.map(p => {
                    return (
                        <>
                            <Row>
                                <p>{p.value}</p>
                            </Row>
                            <br/>
                        </>
                    )
                })}
            </>

        )
    }

    return (
        <>
            { reminder && (getReminder()) }
            { showCoxaInfo && (getCoxaInfo()) }
            {/* isKidneyDept && (getKidneyDept()) */}
            { genericPhrases && data.type !== TYPE_COXA_TREATMENT_PERIOD && (getCommonGenericPhrases()) }
        </>
    )

}